import {
  useParams,
  useSearchParams
} from 'react-router-dom';
import { DropdownSelect } from 'src/viewLayer/components/DesignSystem';

import { buildValidFlowPath } from 'src/viewLayer/helpers/pathHelpers';
import { LOCALE } from 'src/dataLayer/env';
import { DisplayLanguageItems } from 'src/types/learnLanguage';

const Dropdown = ({ languageItems }: { languageItems: DisplayLanguageItems }): JSX.Element => {
  const { environment, flowId, learnLang } = useParams();
  const [queryParams] = useSearchParams();

  const onValueChange = (selectedLanguage: string): void => {
    const redirectPath = buildValidFlowPath({ locale: selectedLanguage, environment, learnLang, flowId, queryParams });
    window.location.replace(redirectPath);
  };

  return (
    <DropdownSelect
      id="uat-displayLanguage-selection"
      items={languageItems}
      value={LOCALE}
      onValueChange={onValueChange}
      modal={false}
    />
  );
};

export default Dropdown;
